/* hs-eslint ignored failing-rules */
/* eslint-disable react/display-name */

'use es6';

import { PureComponent } from 'react';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
import { getCustomContextValue } from 'conversations-message-history/context-update/operators/contextUpdateGetters';
import { jsx as _jsx } from "react/jsx-runtime";
const propTypes = {
  message: RecordPropType('ContextUpdateMessage').isRequired
};
class CustomContextUpdate extends PureComponent {
  render() {
    const {
      message
    } = this.props;
    const customMessage = getCustomContextValue(message);
    return /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "conversations-thread-view.threadHistory.context-update-message.custom",
      options: {
        customMessage
      }
    });
  }
}
CustomContextUpdate.propTypes = propTypes;
export default CustomContextUpdate;